module.exports = __webpack_public_path__ + "static/media/bgContact.70bd1270.jpg";